import { axiosClient, buildUrl, reportError } from './common';

const ISSUES_TYPE = 'issues';
const SUGGESTIONS_TYPE = 'suggestions';

async function getAnnotations(uuid) {
  try {
    const { data: { rows } } = await axiosClient.get(
      buildUrl(uuid, 'annotations', 'search'),
    );
    return rows;
  } catch (err) {
    reportError(err);
    return null;
  }
}

async function _addAnnotation(uuid, annotation, type) {
  try {
    const { data } = await axiosClient.post(
      buildUrl(uuid, 'annotations', type),
      annotation,
    );

    return data;
  } catch (err) {
    reportError(err);
    return null;
  }
}

async function addAnnotationIssue(uuid, annotation) {
  const data = await _addAnnotation(uuid, annotation, ISSUES_TYPE);
  return data;
}

async function addAnnotationSuggestion(uuid, annotation) {
  const data = await _addAnnotation(uuid, annotation, SUGGESTIONS_TYPE);
  return data;
}

async function _updateAnnotation(uuid, annotation, type) {
  try {
    const { id } = annotation;
    const { data } = await axiosClient.put(
      buildUrl(uuid, 'annotations', type, id),
      annotation,
    );

    return data;
  } catch (err) {
    reportError(err);
    return null;
  }
}

async function updateAnnotationIssue(uuid, annotation) {
  const data = await _updateAnnotation(uuid, annotation, ISSUES_TYPE);
  return data;
}

async function updateAnnotationSuggestion(uuid, annotation) {
  const data = await _updateAnnotation(uuid, annotation, SUGGESTIONS_TYPE);
  return data;
}

async function _deleteAnnotation(uuid, id, type) {
  try {
    await axiosClient.delete(buildUrl(uuid, 'annotations', type, id));
    return true;
  } catch (err) {
    reportError(err);
    return false;
  }
}

async function deleteAnnotationIssue(uuid, id) {
  const success = await _deleteAnnotation(uuid, id, ISSUES_TYPE);
  return success;
}

async function deleteAnnotationSuggestion(uuid, id) {
  const success = await _deleteAnnotation(uuid, id, SUGGESTIONS_TYPE);
  return success;
}

export default {
  getAnnotations,
  addAnnotationIssue,
  addAnnotationSuggestion,
  updateAnnotationIssue,
  updateAnnotationSuggestion,
  deleteAnnotationIssue,
  deleteAnnotationSuggestion,
};
